// extracted by mini-css-extract-plugin
module.exports = {"title":"bulletList_title___BHLx","itemWrapper":"bulletList_itemWrapper__YEoe0","column":"bulletList_column___BL4S","listItem":"bulletList_listItem__Ihymz"};